import type { ComponentProps } from 'react'
import React from 'react'
import InputLabelListItem from './InputLabelListItem'
import type CheckboxButton from '../Checkbox/CheckboxButton'
import Switch from '../Switch/Switch'

type InputPropsNames = 'defaultChecked' | 'checked' | 'onChange'
type InheritedCheckboxButtonProps = Pick<ComponentProps<typeof CheckboxButton>, InputPropsNames>
type InheritedInputLabelListItemProps = Omit<ComponentProps<typeof InputLabelListItem>, 'input' | 'ref' | 'onClick' | InputPropsNames>

interface Props extends InheritedInputLabelListItemProps, InheritedCheckboxButtonProps {
}

function SwitchListItem({
  defaultChecked,
  checked,
  onChange,
  ...rest
}: Props) {
  return <InputLabelListItem
    {...rest}
    input={<Switch
      defaultChecked={defaultChecked}
      checked={checked}
      onChange={onChange}
    />}
  />
}

export default SwitchListItem
